<!--
 * @Author: xu xuejia
 * @Date: 2021-11-18 10:40:03
 * @LastEditors: Haiting Zhao
 * @LastEditTime: 2021-12-19 13:11:03
 * @Description: 用户管理
 * @FilePath: \Management-of-Scientific-Research-in-Universities-Front\src\views\systemmanage\User.vue
-->
<template>
  <div>
    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:10px">
      <el-breadcrumb-item :to="{ name:'WorkPlace' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图 -->
    <el-card>
      <el-row>
        <el-col>
          <el-button icon="el-icon-plus" type="primary" style="margin-bottom:10px" @click="AddUserDialogVisible = true">
            添加用户
          </el-button>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <el-table :data="userlist.slice((queryInfo.pagenum-1)*queryInfo.pagesize,queryInfo.pagenum*queryInfo.pagesize)" border stripe>
        <!-- stripe: 斑马条纹
        border：边框-->
        <el-table-column type="index" label="序号" :show-overflow-tooltip="true" />
        <el-table-column prop="username" label="用户名" :show-overflow-tooltip="true" />
        <el-table-column prop="userNumber" label="学工号" :show-overflow-tooltip="true" />
        <el-table-column prop="userEmail" label="邮箱" :show-overflow-tooltip="true" />
        <el-table-column prop="userMobile" label="电话" :show-overflow-tooltip="true" />
        <el-table-column prop="roleName" label="角色" :show-overflow-tooltip="true" />
        <el-table-column prop="userRealname" label="用户真实名字" :show-overflow-tooltip="true" />
        <!-- <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.mg_state" inactive-color="#13ce66" active-color="#ff4949" @change="userStateChanged(scope.row)" />
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="340px">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="showEditDialog(scope.row)"
            >编辑</el-button>
            <el-button
              type="danger"
              icon="el-icon-lock"
              size="mini"
              @click="showresetPswDialog(scope.row.userId)"
            >重置密码</el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="removeUserById(scope.row)"
            >删除</el-button>
            <el-tooltip
              class="item"
              effect="dark"
              content="角色分配"
              :enterable="false"
              placement="top"
            >
              <el-button
                type="warning"
                icon="el-icon-setting"
                size="mini"
                circle
                @click="showSetRole(scope.row)"
              />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        style="text-align: right;"
        :current-page="queryInfo.pagenum"
        :page-sizes="[2, 5, 10, 15]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totle"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <!-- 分配角色对话框 -->
    <el-dialog title="分配角色" :visible.sync="setRoleDialogVisible" width="50%" @close="setRoleDialogClosed">
      <div>
        <p>当前用户：{{ userInfo.username }}</p>
        <p>当前角色：{{ userInfo.roleName }}</p>
        <p>
          分配角色：
          <el-select
            v-model="selectRoleId"
            filterable
            allow-create
            default-first-option
            placeholder="请选择角色"
          >
            <el-option
              v-for="item in rolesLsit"
              :key="item.id"
              :label="item.roleName"
              :value="item.roleId"
            />
          </el-select>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setRoleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveRoleInfo">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加用户对话框 -->
    <el-dialog
      title="添加用户"
      :visible.sync="AddUserDialogVisible"
      width="40%"
      @close="addUserDialogClosed"
    >
      <el-form
        ref="addUserFormRef"
        :model="addUserForm"
        :rules="addUserFormRules"
        label-width="100px"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="addUserForm.username" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addUserForm.password" type="password" autocomplete="off" />
        </el-form-item>
        <el-form-item label="学工号" prop="userNumber">
          <el-input v-model="addUserForm.userNumber" />
        </el-form-item>
        <el-form-item label="姓名" prop="userRealName">
          <el-input v-model="addUserForm.userRealName" />
        </el-form-item>
        <el-form-item label="邮箱" prop="userEmail">
          <el-input v-model="addUserForm.userEmail" />
        </el-form-item>
        <el-form-item label="手机" prop="userMobile">
          <el-input v-model="addUserForm.userMobile" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUsers">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑用户对话框 -->
    <el-dialog
      title="编辑用户"
      :visible.sync="EditUserDialogVisible"
      width="40%"
      @close="EditUserDialogClosed"
    >
      <el-form
        ref="editUserFormRef"
        :model="editUserForm"
        :rules="editUserFormRules"
        label-width="100px"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="editUserForm.username" />
        </el-form-item>
        <el-form-item label="学工号" prop="userNumber">
          <el-input v-model="editUserForm.userNumber" />
        </el-form-item>
        <el-form-item label="姓名" prop="userRealName">
          <el-input v-model="editUserForm.userRealName" />
        </el-form-item>
        <el-form-item label="邮箱" prop="userEmail">
          <el-input v-model="editUserForm.userEmail" />
        </el-form-item>
        <el-form-item label="手机" prop="userMobile">
          <el-input v-model="editUserForm.userMobile" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EditUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUsers">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 重置密码对话框 -->
    <el-dialog
      title="重置密码"
      :visible.sync="resetPswDialogVisible"
      width="40%"
      @close="resetPswDialogClosed"
    >
      <el-form
        ref="editRoleFormRef"
        :model="resetPswForm"
        :rules="resetPswFormRules"
        label-width="100px"
      >
        <el-form-item label="新密码" prop="password">
          <el-input v-model="resetPswForm.password" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetPswDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="resetPsw">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'User',
  data() {
    // 自定义邮箱规则
    var checkEmail = (rule, value, callback) => {
      const regEmail = /^\w+@\w+(\.\w+)+$/
      if (regEmail.test(value)) {
        // 合法邮箱
        return callback()
      }
      callback(new Error('请输入合法邮箱'))
    }
    // 自定义手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^1[3456789]\d{9}$/
      if (regMobile.test(value)) {
        return callback()
      }
      // 返回一个错误提示
      callback(new Error('请输入合法的手机号码'))
    }
    return {
      // 获取用户列表查询参数对象
      queryInfo: {
        query: '',
        // 当前页数
        pagenum: 1,
        // 每页显示多少数据
        pagesize: 5
      },
      userlist: [],

      totle: 0,
      // 添加用户对话框
      AddUserDialogVisible: false,
      // 添加用户表单
      addUserForm: {},
      // 添加用户表单验证
      addUserFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        userNumber: [
          { required: true, message: '请输入学工号', trigger: 'blur' }
        ],
        userRealName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        userEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ],
        userMobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ]
      },

      // 修改用户
      EditUserDialogVisible: false,
      editUserForm: {
        username: '',
        userNumber: '',
        userRealName: '',
        userEmail: '',
        userMobile: ''
      },
      // 编辑用户表单验证
      editUserFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        userNumber: [
          { required: true, message: '请输入学工号', trigger: 'blur' }
        ],
        userRealName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        userEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ],
        userMobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ]
      },
      //   重置密码信息
      resetPswForm: {},
      resetPswDialogVisible: false,
      resetPswFormRules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ]
      },
      userId: '',
      // 分配角色对话框
      setRoleDialogVisible: false,
      // 当前需要被分配角色的用户
      userInfo: {},
      // 所有角色数据列表
      rolesLsit: [],
      // 已选中的角色Id值
      selectRoleId: ''

    }
  },
  created() {
    this.getUserList()
  },
  methods: {
    /**
     * @description: 获取用户列表
     * @param {*}
     * @return {*}
     * @author: xu xuejia
     */
    getUserList() {
      axios.get('/user/getUsers').then((response) => {
        // console.log('response', response)
        this.userlist = response.data.data
        this.totle = this.userlist.length
      }).catch(error => {
        console.log(error)
      })
    },
    /**
     * @description: 页码以及页面条数改变
     * @param {*}
     * @return {*}
     * @author: xu xuejia
     */
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize
      this.getUserList()
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagenum = newSize
      this.getUserList()
    },
    /**
     * @description: 状态禁用
     * @param {*}
     * @return {*}
     * @author: xu xuejia
     */
    // 监听 switch开关 状态改变
    // 状态禁用开关：
    userStateChanged(userInfo) {
      // console.log(userInfo.userId)
      userInfo.userStatus = !userInfo.userStatus
      axios.get(`user/delete?userId=${userInfo.userId}`)
        .then(() => {
          this.$message.success('更新用户状态成功！')
        })
        .catch((err) => {
          this.$message.info(err.msg)
        })
      this.getUserList()
    },
    /**
     * @description: 删除用户
     * @param {*}
     * @return {*}
     * @author: xu xuejia
     */
    // 删除用户
    async removeUserById(role) {
      // console.log(role.userId)
      const confirmResult = await this.$confirm(
        '此操作将永久删除该用户, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      // 点击确定 返回值为：confirm
      // 点击取消 返回值为： cancel
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.axios.get(`user/delete?userId=${role.userId}`)
      if (res.meta.status !== 200) return this.$message.error('删除用户失败！')
      this.$message.success('删除用户成功！')
      this.getUserList()
    },
    /**
     * @description: 分配角色对话框
     * @param {*}
     * @return {*}
     * @author: xu xuejia
     */
    // 展示分配角色的对话框
    showSetRole(role) {
      // console.log(role.userId)
      this.userInfo = role
      axios.get('role/getRoles').then((response) => {
        this.rolesLsit = response.data.data
      }).catch(error => {
        console.log(error)
      })

      this.setRoleDialogVisible = true
    },
    /**
     * @description: 分配角色
     * @param {*}
     * @return {*}
     * @author: xu xuejia
     */
    // 分配角色
    saveRoleInfo() {
      if (!this.selectRoleId) {
        return this.$message.error('请选择要分配的角色')
      }
      axios.post('user/updateUserRole', {
        roleId: this.selectRoleId, userId: this.userInfo.userId
      }).then((response) => {
        // console.log(response.data)
        if (response.data.code !== 200) {
          return this.$message.error('更新用户角色失败！')
        } else { return this.$message.success('更新角色成功！') }
      })
      this.getUserList()
      this.setRoleDialogVisible = false
    },
    /**
     * @description: 分配角色对话框关闭事件
     * @param {*}
     * @return {*}
     * @author: xu xuejia
     */
    // 分配角色对话框关闭事件
    setRoleDialogClosed() {
      this.selectRoleId = ''
      this.userInfo = {}
    },

    /**
     * @description: 添加用户对话框的关闭
     */
    addUserDialogClosed() {
      this.$refs.addUserFormRef.resetFields()
    },
    /**
     * @description: 添加用户
     */
    addUsers() {
      axios.post('/user/register', {
        username: this.addUserForm.username,
        password: this.addUserForm.password,
        userNumber: this.addUserForm.userNumber,
        userRealname: this.addUserForm.userRealName,
        userEmail: this.addUserForm.userEmail,
        userMobile: this.addUserForm.userMobile
      })
        .then(res => {
          console.log(res)
          if (res.data.code === 200) {
            this.$message.success(res.data.msg)
            this.AddUserDialogVisible = false
            this.getUserList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },

    /**
     * @description: 显示编辑用户框
     */
    showEditDialog(user) {
      console.log('========')
      console.log(user)
      this.EditUserDialogVisible = true
      this.userId = user.userId
      this.editUserForm.username = user.username
      this.editUserForm.userNumber = user.userNumber
      this.editUserForm.userRealName = user.userRealname
      this.editUserForm.userEmail = user.userEmail
      this.editUserForm.userMobile = user.userMobile
    },

    /**
     * @description: 编辑用户
     */
    editUsers() {
      axios.post('/user/update', {
        userId: this.userId,
        username: this.editUserForm.username,
        userNumber: this.editUserForm.userNumber,
        userRealname: this.editUserForm.userRealName,
        userEmail: this.editUserForm.userEmail,
        userMobile: this.editUserForm.userMobile
      })
        .then(res => {
          // console.log(res)
          if (res.data.code === 200) {
            this.$message.success(res.data.msg)
            this.EditUserDialogVisible = false
            this.getUserList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    EditUserDialogClosed() {
      this.EditUserDialogVisible = false
    },

    /**
     * @description: 显示重置密码框
     */
    showresetPswDialog(user) {
      this.resetPswDialogVisible = true
      this.userId = user
    },
    /**
     * @description: 重置密码
     */
    resetPsw() {
      axios.post('/user/resetPwd', {
        userId: this.userId,
        newPassword: this.resetPswForm.password
      })
        .then(res => {
          // console.log(res)
          if (res.data.code === 200) {
            this.$message.success(res.data.msg)
            this.resetPswDialogVisible = false
            this.getUserList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    resetPswDialogClosed() {
      this.resetPswDialogVisible = false
    }
  }
}
</script>
<style>

</style>
